/* Angular Component */
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ExternalMAMGatewayProviderInfo } from "app/js/src/domain/external-mam/external-mam-gateway-provider-info";
import { ExternalMAMServiceProvider } from "app/js/src/domain/external-mam/external-mam-service-provider";

@Component({
  selector: "external-mam-gateways-card",
  templateUrl: "./external-mam-gateways-card.component.html",
  styleUrls: ["./external-mam-gateways-card.component.scss"],
})
export class ExternalMAMGatewaysCardComponent {
  constructor(private sanitizer: DomSanitizer) {}
  @Input()
  service: ExternalMAMServiceProvider;
  @Input()
  gateway: ExternalMAMGatewayProviderInfo;
  @Input()
  public isExternalMAMEditor: boolean = false;
  @Output()
  goToSearch = new EventEmitter();
  @Output()
  goToEdit = new EventEmitter();

  displayLogo(logo) {
    return this.sanitizer.bypassSecurityTrustUrl(
      `data:image/svg+xml;base64,${logo}`,
    );
  }

  searchClicked() {
    this.goToSearch.emit();
  }
  editClicked() {
    this.goToEdit.emit();
  }
}
